import React from 'react';
import { IconWorld } from '@tabler/icons-react';

const FLAG_BASE = '/images/flags';

function CountryFlag({ code, label, size = 16 }) {
    const iso = String(code || '').trim().toLowerCase();
    if (!iso) {
        return <IconWorld size={size} stroke={1.75} className="tw-text-muted tw-flex-shrink-0" aria-hidden />;
    }
    return (
        <img
            src={`${FLAG_BASE}/${iso}.svg`}
            alt={label || iso.toUpperCase()}
            title={label || iso.toUpperCase()}
            onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = `${FLAG_BASE}/xx.svg`;
            }}
            className="tw-flex-shrink-0 tw-rounded-brand-xs tw-shadow-flag-inset"
            style={{ height: size, width: Math.round((size * 4) / 3), objectFit: 'cover' }}
        />
    );
}

export default CountryFlag;
